export const V3IconLock = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
        <path stroke="#abb0ba" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 6.5V4a3 3 0 1 1 6 0v2.5" />
        <rect width="12" height="8" x="2" y="7" stroke="#abb0ba" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" rx="1.5" />
    </svg>
);
